export class bannerModal{
    routeLink : string;
    value : string;
}